export const DS_TOOLTIP_CLASSES = {
  Tooltip: "ds-tooltip",
  Title: "ds-tooltip__title",
  Body: "ds-tooltip__body",
  Text: "ds-tooltip__text",
} as const;
